import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./SetPassword.css"; // Reutiliza los mismos estilos que tu setPassword

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [validating, setValidating] = useState(true);
  const [validToken, setValidToken] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const token = searchParams.get("token");

  // 🔍 Validar token cuando la página carga
  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setMessage("Token no válido.");
        setValidating(false);
        return;
      }

      try {
        const res = await fetch("http://te-ayudo.es/back/api/validate_token_password.php?token=" + token);

        const data = await res.json();
        if (data.ok) {
          setValidToken(true);
        } else {
          setMessage("El enlace ha expirado o no es válido.");
        }
      } catch (err) {
        setMessage("Error al verificar el token.");
      } finally {
        setValidating(false);
      }
    };

    checkToken();
  }, [token]);

  // 🧩 Manejar envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword.length < 8) {
      setMessage("La contraseña debe tener al menos 8 caracteres.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Las contraseñas no coinciden.");
      return;
    }

    setSubmitting(true);
    setMessage("");

    try {
      const res = await fetch("http://te-ayudo.es/back/api/reset_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: newPassword }),
      });

      const data = await res.json();

      if (data.ok) {
        setMessage("✅ Contraseña actualizada correctamente. Redirigiendo al login...");
        setTimeout(() => navigate("/", { replace: true }), 2000);
      } else {
        setMessage("❌ " + (data.error || "No se pudo actualizar la contraseña."));
      }
    } catch (err) {
      setMessage("Error al conectar con el servidor.");
    } finally {
      setSubmitting(false);
    }
  };

  if (validating) return <div className="password-container">Verificando enlace...</div>;

  if (!validToken) return <div className="password-container error">{message}</div>;

  return (
    <div className="password-container">
      <h2>🔑 Restablecer contraseña</h2>

      <form onSubmit={handleSubmit} className="password-form">
        <label>Nueva contraseña</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Introduce tu nueva contraseña"
          required
        />

        <label>Confirmar contraseña</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Repite tu nueva contraseña"
          required
        />

        <button type="submit" disabled={submitting}>
          {submitting ? "Guardando..." : "Actualizar contraseña"}
        </button>

        {message && <p className="message">{message}</p>}
      </form>
    </div>
  );
}
